import React, { Component } from 'react'
import { styles } from '../styles'
import withStyles from 'material-ui/styles/withStyles'
import withTheme from 'material-ui/styles/withTheme'
import {compose} from 'redux'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import Typography from 'material-ui/Typography/Typography'
import SwipeableViews from 'react-swipeable-views'
//import { connect } from 'react-redux'

import Card, {  CardContent } from 'material-ui/Card'
//import Button from 'material-ui/Button'

//import IconButton from 'material-ui/IconButton'
//import Input, { InputLabel, InputAdornment } from 'material-ui/Input'
//import { FormControl, FormHelperText } from 'material-ui/Form'

//import Email from 'material-ui-icons/Email'
//import Visibility from 'material-ui-icons/Visibility'
//import VisibilityOff from 'material-ui-icons/VisibilityOff'
//import ArrowForward from 'material-ui-icons/ArrowForward'
import GoogleLoginButton from 'react-social-login-buttons/lib/buttons/GoogleLoginButton'
import FacebookLoginButton from 'react-social-login-buttons/lib/buttons/FacebookLoginButton'
import withWidth from 'material-ui/utils/withWidth'
import Link from 'react-router-redux-dom-link'

import {firebaseConnect, isEmpty} from 'react-redux-firebase'

import {Redirect} from 'react-router'


class SignInContainer extends Component {
    state = {
        email: "",
        password: "",
        showPassword: false,
        index: 0,
        signInLoading: false,
    }
    handleMouseDownPassword = event => {
        event.preventDefault();
    }
    handleClickShowPasssword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    }
    handleChange = prop => event => {
        this.setState({ [prop]: event.target.value });
    }
    render() {
        return(
            isEmpty(this.props.firebase.auth)?<Redirect to={{pathname: 'signin'}}/>
            :
            <div>
                <Grid container style={{marginTop: "0px"}} className={this.props.classes.centerGrid} spacing={0}>
                    <Grid item xs={12} md={4}>
                        <Paper className={this.props.classes.paper}>
                            <SwipeableViews index={this.state.index} onChangeIndex={(index) => this.setState({index})}>
                                <Card className={this.props.classes.card}>
                                
                                    <CardContent style={{width: "500px"}}>
                                    <Typography variant="headline">
                                    นวัตกรรมการเลือกคณะด้วย AI
                                    </Typography>
                                    </CardContent>
                                </Card>
                            </SwipeableViews>
                            
                        </Paper>
                        {/*<center><Dots
                                index={this.state.index}
                                count={1}
                                dotColor="#C52C2C"
                        onDotClick={(index) => this.setState({index})} /></center>*/}
                        
                    </Grid>
                    <Grid item xs={12} md={4} className={this.props.classes.itemGrid}>
                        {/*
                        <Typography type="title" color="default" >
                            กรอกอีเมลและรหัสผ่านเพื่อเข้าสู่ระบบ
                        </Typography>
                        
                        <FormControl fullWidth style={{width: '95%'}} className={this.props.classes.formControl}>
                            <InputLabel htmlFor="email">อีเมล</InputLabel>
                            <Input
                                className={this.props.classes.fullTextInput}
                                type="email"
                                onChange={this.handleChange('email')}
                                value={this.state.email}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton>
                                            <Email/>
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                        <FormControl fullWidth style={{width: '95%'}} className={this.props.classes.formControl}>
                            <InputLabel htmlFor="password">รหัสผ่าน</InputLabel>
                            <Input
                                className={this.props.classes.fullTextInput}
                                type={this.state.showPassword ? "text":"password"}
                                value={this.state.password}
                                onChange={this.handleChange('password')}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={this.handleClickShowPasssword}
                                            onMouseDown={this.handleMouseDownPassword}>
                                            {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                        <FormControl  fullWidth className={this.props.classes.formControl}>
                            <Button  
                                variant="raised"
                                size="large"
                                color="secondary"
                                className={this.props.classes.fullButton}
                               // onClick={()=>this.props.loadingStart('เข้าสู่ระบบ')}
                               >
                                
                                <span style={{fontSize: '120%'}}>

                                    ลงชื่อเข้าใช้
                                </span>
                            </Button>
                        </FormControl>*/}
                        <Grid style={{flexDirection: 'row'}} className={this.props.classes.centerGrid} >
                            <Grid item xs={6} md={6} >
                                <FacebookLoginButton 
                                    onClick={()=>this.props.firebase.login({provider: 'facebook', type: 'popup'})}
                                    text={this.props.width === 'xs'?"Facebook":"เข้าสู่ระบบด้วย Facebook"}/>
                            </Grid>
                            <Grid item xs={6} md={6} >
                                <GoogleLoginButton
                                    onClick={()=>this.props.firebase.login({provider: 'google', type: 'popup'})}
                                    text={this.props.width === 'xs'?"Google":"เข้าสู่ระบบด้วย Google"}/>
                            </Grid>
                        </Grid>
                        <Typography type="caption">
                            ข้าพเจ้าได้อ่าน <Link to="/termsOfService">ข้อตกลงในการใช้บริการ</Link> และ <Link to="/privacy">ข้อตกลงเกี่ยวด้วยสิทธิความเป็นส่วนตัว</Link> แล้ว
                        </Typography>
                    </Grid>
                </Grid>
                
            </div>
        )
    }
}


export default compose(firebaseConnect(),withTheme(),withStyles(styles), withWidth())(SignInContainer)


// WEBPACK FOOTER //
// ./src/signin/SigninContainer.js